import { useState } from 'react';
import ApplicationModal from './ApplicationModal';

export default function HeroSection() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleApply = () => {
    setIsModalOpen(true);
  };

  return (
    <>
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: 'url(https://public.readdy.ai/ai/img_res/6217319aaaeeef16271078b356e04823.jpg)',
          }}
        ></div>

        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>

        <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 text-center text-white">
          <div className="inline-flex items-center space-x-2 bg-white/20 backdrop-blur-md px-6 py-3 rounded-full mb-8">
            <i className="ri-award-line text-2xl"></i>
            <span className="text-sm font-bold tracking-wider">PROFESSIONAL CERTIFICATION</span>
          </div>

          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-black leading-tight mb-8">
            Miss Mirage<br />
            プロフェッショナル<br />
            ネイルエデュケーター<br />
            認定プログラム
          </h1>

          <p className="text-xl lg:text-2xl mb-6 max-w-3xl mx-auto leading-relaxed font-medium">
            ネイリストとしての技術を、<br className="sm:hidden" />次世代へ継承する。<br />
            認定取得後、あなた自身の<br className="sm:hidden" />ネイリスト養成スクールを開講できます
          </p>

          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-8 max-w-4xl mx-auto mb-12">
            <h3 className="text-2xl font-bold mb-6">
              なぜ今、<br className="sm:hidden" />エデュケーターなのか？
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-left">
              <div className="flex items-start space-x-3">
                <i className="ri-time-line text-3xl text-rose-300 flex-shrink-0 mt-1"></i>
                <div>
                  <h4 className="font-bold text-lg mb-2">プレーヤーの限界</h4>
                  <p className="text-sm text-white/90">ネイリストとしての現場人生は長くない。次のキャリアステージへ</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-team-line text-3xl text-rose-300 flex-shrink-0 mt-1"></i>
                <div>
                  <h4 className="font-bold text-lg mb-2">人材育成の課題</h4>
                  <p className="text-sm text-white/90">新卒教育はコスト高、中途採用は社風リスク。自分で育てる選択を</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-store-line text-3xl text-rose-300 flex-shrink-0 mt-1"></i>
                <div>
                  <h4 className="font-bold text-lg mb-2">収益の多角化</h4>
                  <p className="text-sm text-white/90">スクール運営で物販も可能。安定した収入源を確保</p>
                </div>
              </div>
            </div>
          </div>

          <button
            onClick={handleApply}
            className="inline-flex items-center space-x-3 px-12 py-6 bg-gradient-to-r from-pink-400 to-rose-400 text-white text-xl font-bold rounded-full hover:shadow-2xl hover:scale-105 transition-all cursor-pointer whitespace-nowrap"
          >
            <span>お申し込みボタン（準備中）</span>
            <i className="ri-arrow-right-line text-2xl"></i>
          </button>
        </div>
      </section>

      <ApplicationModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
}